import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcPurchaseApplicationHeader from '@/types/table/wkcPurchaseApplicationHeader';
import { WkcPurchaseApplicationDetailsData } from '@/api/generated/wkcPurchaseApplicationDetailsController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcPurchaseApplicationHeaderData extends WkcPurchaseApplicationHeader {
  wkcPurchaseApplicationDetailsList?: WkcPurchaseApplicationDetailsData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcPurchaseApplicationHeaderController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcPurchaseApplicationHeaderData>>(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcPurchaseApplicationHeaderData>(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/deleteBatch', params, httpOptions);
  }
  static startOnlyWkcPurchaseApplication(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/startOnly/WkcPurchaseApplication', params, httpOptions);
  }
  static startWithBusinessKeyWkcPurchaseApplication(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/startWithBusinessKey/WkcPurchaseApplication', params, httpOptions);
  }
  static startAndTakeUserTaskWkcPurchaseApplication(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/startAndTakeUserTask/WkcPurchaseApplication', params, httpOptions);
  }
  static startAndSaveDraftWkcPurchaseApplication(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/startAndSaveDraft/WkcPurchaseApplication', params, httpOptions);
  }
  static submitUserTaskWkcPurchaseApplication(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/submitUserTask/WkcPurchaseApplication', params, httpOptions);
  }
  static viewTaskBusinessDataWkcPurchaseApplication(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/viewTaskBusinessData/WkcPurchaseApplication', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataWkcPurchaseApplication(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/viewHistoricTaskBusinessData/WkcPurchaseApplication', params, httpOptions);
  }
  static listWorkOrderWkcPurchaseApplication(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationHeader/listWorkOrder/WkcPurchaseApplication', params, httpOptions);
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
    static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
      return super.post<TableData<WkcPurchaseApplicationHeaderData>>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
    }
}
